import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center gap-4" }
const _hoisted_2 = { class: "flex flex-col place-items-center overflow-hidden" }
const _hoisted_3 = ["src"]

import BaseCard from '@/features/global/BaseCard.vue';
import PovoPrototype from '@/assets/Projects/PovoPhotos/PovoPrototype.jpg';
import { useImageViewer } from '@/features/composables/useImageViewer';


export default /*@__PURE__*/_defineComponent({
  __name: 'PovoProjectSpec',
  setup(__props) {

const { openImageMenu } = useImageViewer();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCard, {
    title: 'POVO Class Registration Interface',
    highlightLastWord: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "lg:w-full grid lg:grid-cols-2 lg:gap-20" }, [
          _createElementVNode("h5", { class: "lg:justify-self-end lg:pr-6 font-medium" }, "Project Leader"),
          _createElementVNode("h5", { class: "lg:justify-self-start lg:pl-6 font-medium" }, "January 2025 - January 2026")
        ], -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-center items-center px-4 gap-2 justify-center" }, [
          _createElementVNode("span", { class: "block" }, "As part of my Human Computer Interaction course, my professor tasked my group of 3 to implement a full-scale redesign of a platform of our choice, one primarily that fails to address user needs and HCI-based principles. Given that we had heard thousands of complaints about Notre Dame's course registration softwares (yes, two separate softwares), PATH and NOVO, we focused on combining these two into one full-fledged platform that handled both course search and registration with speed and ease of use."),
          _createElementVNode("span", { class: "block" }, "We broke down our project into 4 sprints: user research, brainstorming/prototyping, Figma design and web prototyping, and summative user evaluation."),
          _createElementVNode("span", { class: "block" }, " In Sprint 1, we conducted 7 user interviews spanning all 4 undergraduate years, graduate students, faculty, and various majors. We designed our interview process to capture diverse perspectives, and we found over 50 failures in satisfying user needs. "),
          _createElementVNode("span", { class: "block" }, " These interviews then led into Sprint 2, where we drew about 150 sketches to iterate through users' needs and our ideas on addressing them. Because of our differing interviews, each of us drew entirely different ideas taht emphasized different needs, yet I worked with the my two group members to combine our ideas into 6 \"How Might We\" statements that addressed the primary needs. We then used these statements to implement 6 final design prototypes that we took to users, receiving very positive feedback. "),
          _createElementVNode("span", { class: "block" }, [
            _createTextVNode(" Moving forward to Sprint 3, I used my expertise in reactive web design to implement a reactive, single-page prototype named "),
            _createElementVNode("a", {
              href: "https://povo-interface-online.web.app/",
              target: "_blank",
              class: "photo-link"
            }, "POVO"),
            _createTextVNode(". Taking our prototype to 3 PhD students and our peers, we received immensely positive feedback, from students asking \"Will this be released next week in time for registration?\" to \"Can you please take this to the administration?\" Even still, our work wasn't finished as we needed to improve from critical feedback and evaluate our prototype. ")
          ]),
          _createElementVNode("span", { class: "block" }, " In Sprint 4, each of us conducted a heurstic evaluation first to gather potential improvements that I later implemented in the POVO prototype. Then, we conducted 11 summative evaluations, with users taking on 3 tasks each that reflected the general flow of course registration throughout PATH/NOVO and POVO. In these evaluations, we kept track of users' comments as well as their completion time, frustration, and NASA TLX Evaluaton Surveys. In the quantitative data, we found the following very positive results: ")
        ], -1)),
        _cache[3] || (_cache[3] = _createElementVNode("ul", { class: "text-center items-center justify-center" }, [
          _createElementVNode("li", null, "A 90% decrease in task completion time between PATH/NOVO and POVO"),
          _createElementVNode("li", null, "3.73/20 average mental demand from TLX survey (lower than PATH/NOVO)"),
          _createElementVNode("li", null, "4.0/20 average temporal demand (much lower than PATH/NOVO)"),
          _createElementVNode("li", null, "4.06/20 average effort (slightly lower than PATH/NOVO)"),
          _createElementVNode("li", null, "3.4/20 average frustration (staggeringly lower than PATH/NOVO)")
        ], -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", null, [
          _createTextVNode(" For more details, check out our nearly 70-page "),
          _createElementVNode("a", {
            href: "https://docs.google.com/document/d/1FWvtfMxiwoWXePhVTn7zi39D3eHltyPQMtqWOpfCSvA/edit?usp=sharing",
            target: "_blank",
            class: "link-in-text"
          }, "Design Document"),
          _createTextVNode(" detailing all 4 sprints or the "),
          _createElementVNode("a", {
            href: "https://povo-interface-online.web.app/",
            target: "_blank",
            class: "link-in-text"
          }, "POVO prototype"),
          _createTextVNode(" itself! ")
        ], -1)),
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("img", {
            class: "w-[50%] h-auto rounded-lg cursor-pointer",
            src: _unref(PovoPrototype),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openImageMenu)(_unref(PovoPrototype), 'POVO Interface', $event.currentTarget)))
          }, null, 8, _hoisted_3)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})